/* Zorix theme core JS */

(function(){
  'use strict';

  // ---- Mobile menu toggle ----
  document.addEventListener('click', function(e){
    const btn = e.target.closest('[data-menu-toggle]');
    if(!btn) return;
    const nav = document.querySelector('[data-mobile-nav]');
    if(nav){ nav.classList.toggle('open'); }
  });

  // ---- Quantity pickers ----
  document.addEventListener('click', function(e){
    const inc = e.target.closest('[data-qty-inc]');
    const dec = e.target.closest('[data-qty-dec]');
    if(!inc && !dec) return;
    const wrap = (inc||dec).closest('.qty-picker');
    if(!wrap) return;
    const input = wrap.querySelector('input[type="number"]');
    if(!input) return;
    let v = parseInt(input.value,10) || 1;
    if(inc) v++;
    if(dec) v = Math.max(1, v-1);
    input.value = v;
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });

  // ---- Product gallery (thumbnail click) ----
  document.addEventListener('click', function(e){
    const thumb = e.target.closest('[data-gallery-thumb]');
    if(!thumb) return;
    const gallery = thumb.closest('[data-gallery]');
    if(!gallery) return;
    const main = gallery.querySelector('[data-gallery-main] img');
    const newSrc = thumb.dataset.src || thumb.querySelector('img')?.src;
    if(main && newSrc){ main.src = newSrc; }
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(t=>t.classList.remove('active'));
    thumb.classList.add('active');
  });

  // ---- Variant pills (visual selection) ----
  document.addEventListener('click', function(e){
    const pill = e.target.closest('.variant-pill');
    if(!pill) return;
    const group = pill.closest('.variant-pills');
    if(!group) return;
    group.querySelectorAll('.variant-pill').forEach(p=>p.classList.remove('selected'));
    pill.classList.add('selected');
    const hidden = group.parentElement.querySelector('input[type="hidden"][name="id"]');
    const variantId = pill.dataset.variantId;
    if(hidden && variantId){ hidden.value = variantId; }
  });

  // ---- Add-to-cart via Shopify AJAX API ----
  document.addEventListener('submit', function(e){
    const form = e.target.closest('form[action*="/cart/add"]');
    if(!form || !form.dataset.ajax) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const orig = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Ajout…'; }
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/x-www-form-urlencoded'},
      body:new URLSearchParams(new FormData(form))
    })
    .then(r => { if(!r.ok){ throw new Error('add'); } return r.json(); })
    .then(added => fetch('/cart.js').then(r=>r.json()).then(cart => ({added:added, cart:cart})))
    .then(res => {
      document.querySelectorAll('.cart-badge').forEach(el=>{
        el.textContent = res.cart.item_count;
        el.style.display = res.cart.item_count > 0 ? 'grid' : 'none';
      });
      if(btn){ btn.disabled = false; btn.textContent = orig; }
      if(window.zxCartPopup){ window.zxCartPopup(res.added, res.cart); }
    })
    .catch(()=>{
      if(btn){ btn.disabled = false; btn.textContent = orig; }
      if(window.zxCartPopup){ window.zxCartPopup(null, null); }
    });
  });

  // ---- Cart line removal (cart page) ----
  document.addEventListener('click', function(e){
    const btn = e.target.closest('[data-cart-remove]');
    if(!btn) return;
    e.preventDefault();
    const key = btn.dataset.cartRemove;
    if(!key) return;
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id:key, quantity:0})
    }).then(()=>window.location.reload());
  });

})();
